module.exports = __webpack_public_path__ + "static/media/zameen-opal.107ec5a9.jpg";